// FeedFilterPanelV2.js
'use strict';
import { connect } from 'react-redux';

import {
  LIVESTREAM_FEED_SORTINGS_V2,
  LIVESTREAM_FEED_FILTER_V2_SHORTCUT,
} from '../RemoteConfigKeys.js';
import getModalData from '../selector/getModalData.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import toggleModal from '../action/toggleModal.js';
import {
  setSelectedOption,
  resetSelectedOptions,
} from '../action/feedFilterActions.js';

import FeedFilterPanelV2 from '../component/FeedFilterPanelV2.jsx';

const mapStateToProps = (state, { baseFeedName }) => {
  const sortOptions = getRemoteConfigData(state, LIVESTREAM_FEED_SORTINGS_V2);
  const filterShortcutOptions = getRemoteConfigData(
    state,
    LIVESTREAM_FEED_FILTER_V2_SHORTCUT
  );

  return {
    sortOptions,
    filterShortcutOptions,
    selectedOptions: getOperationData(
      state,
      ['feed', baseFeedName, 'filter_v2'],
      'selectedOptions'
    ),
    deviceWidth: getOperationData(state, ['device'], 'width'),
    isFeedFilterModalOpened: ['opening', 'display'].includes(
      getModalData(state, 'FeedFilterModal', 'status')
    ),
  };
};

const mapDispatchToProps = (dispatch, { baseFeedName }) => {
  return {
    setSelectedOption: payload =>
      dispatch(setSelectedOption({ baseFeedName, ...payload })),
    resetSelectedOptions: () =>
      dispatch(resetSelectedOptions({ baseFeedName })),
    openFeedFilterModal: () =>
      dispatch(toggleModal({ modalId: 'FeedFilterModal', isOpen: true })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedFilterPanelV2);
